import React from "react";
import { get } from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledLabel, StyledTextField } from "./styles";

function CustomTextField({ name, label, placeholder, ...params }) {
  const { control, formState } = useFormContext();
  const { errors } = formState;
  const parsedError = get(errors, name);
  return (
    <Box sx={{ height: "100px" }}>
      <StyledLabel variant="body1" align="left">
        {label}
      </StyledLabel>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field }) => (
          <StyledTextField
            {...field}
            placeholder={placeholder}
            error={!!parsedError || false}
            helperText={parsedError ? parsedError.message : ""}
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: false }}
            {...params}
          />
        )}
      />
    </Box>
  );
}

export default CustomTextField;
